import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { createApiCall } from 'services';

type CompanyByEmbedKeyResponse = {
  id: string;
};

const getCompanyByEmbedKey = async (embedKey: string): Promise<CompanyByEmbedKeyResponse> => {
  const response = await createApiCall({
    method: 'GET',
    url: `/companies/public/exchange-embed-key/${embedKey}`,
    headers: {
      'origin': window.location.origin,
    },
  });

  return response.data as CompanyByEmbedKeyResponse;
};

export const useGetCompanyByEmbedKey = (embedKey: string | null): UseQueryResult<CompanyByEmbedKeyResponse, Error> => {
  return useQuery({
    queryKey: ['companyByEmbedKey', embedKey],
    queryFn: () => getCompanyByEmbedKey(embedKey!),
    enabled: !!embedKey, // Only run query if embed key exists
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    retry: 1, // Only retry once if failed
  });
};
